import type { ContentPage } from "@/lib/content/types";

export const multiPageLayout: ContentPage = {
  slug: "process-management/multi-page-layout",
  template: "hrmsFeature",
  seo: {
    title: "Multi-page Layouts - Tailor CRM Records to Every Team | GetBiz CRM",
    description:
      "Create multiple record layouts in GetBiz CRM so each team, process and stage sees exactly the fields it needs — cleaner screens and faster data entry.",
    keywords: [
      "multi-page layout",
      "CRM page layouts",
      "custom record layouts",
      "dynamic layouts",
      "CRM customization",
      "role based layouts",
    ],
    ogImage: "/assets/data/seoimages/multi-page-layout.webp",
  },
  leaf: {
    hero: {
      caption: "Multi-page Layout",
      title: "Show Every Team Exactly the Fields They Need",
      description:
        "Build multiple layouts for the same record so different teams, processes and stages see only the relevant fields — reducing clutter, errors and data-entry time.",
      h1: "caption",
    },
    split: {
      title: "The Right View for Every Context",
      bullets: [
        { title: "Per-team Layouts", description: "Sales, support and finance each get their own view." },
        { title: "Stage-based Views", description: "Surface the fields that matter at each stage." },
        { title: "Cleaner Screens", description: "Hide noise so reps move faster." },
        { title: "Role Permissions", description: "Control who sees and edits which fields." },
      ],
      image: "/assets/images/img/product/crm/multipage-crm-image.webp",
      imageAlt: "GetBiz CRM multi-page layouts",
    },
    cardsHeading: {
      title: "More Process Management Tools",
      description: "Multi-page Layout works with the rest of GetBiz CRM process management.",
    },
    cards: [
      { title: "Sales Blueprint", href: "/crm-software/process-management/sales-blueprint/", description: "Pair layouts with a guided, staged process.", image: "/assets/images/img/product/crm/sales-blueprint.webp", imageAlt: "CRM sales blueprint" },
      { title: "Validation Rule", href: "/crm-software/process-management/validation-rule/", description: "Enforce valid data on every layout.", image: "/assets/images/img/product/crm/validation-rule.webp", imageAlt: "CRM validation rule" },
      { title: "Review Process", href: "/crm-software/process-management/review-process/", description: "Show reviewers a focused, relevant layout.", image: "/assets/images/img/product/crm/review-process.webp", imageAlt: "CRM review process" },
      { title: "Assignment Rule", href: "/crm-software/process-management/assignment-rule/", description: "Route records to the team whose layout fits.", image: "/assets/images/img/product/crm/assignment-rule.webp", imageAlt: "CRM assignment rule" },
    ],
    testimonials: { title: "Less clutter, faster work", description: "See why teams tailor layouts in GetBiz CRM." },
    bookDemoTitle: "Tailor your CRM to every team.",
    relatedBlogs: "slug",
    relatedBlogsKeyword: "crm-page-layout-customization, crm-customization-guide",
    metaKey: "multi-page-layout",
  },
  sections: [],
};
